export default __webpack_public_path__ + "static/media/aviral.85a2c65e.jpg";